module.exports = __webpack_public_path__ + "img/grey-foot.fe6f1f5e.png";